export const parseStatics = (value: string) => {
    const control = false; // when you share with host return to 'true'

    if (control)
        return value;
    else
        return JSON.parse(value);
}